import type { ReactNode } from "react"
import { Navigate, Outlet, useLocation } from "react-router-dom"
import { Spinner } from "@/components/ui/spinner"
import { useAuth } from "@/contexts/AuthContext"

export function ProtectedRoute({ children }: { children?: ReactNode }) {
  const { isAuthenticated, isLoading, user } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner className="size-8 text-primary" />
      </div>
    )
  }

  if (!isAuthenticated) {
    const redirect = `${location.pathname}${location.search}`
    return <Navigate to={`/login?redirect=${encodeURIComponent(redirect)}`} replace />
  }

  // Pendataan wajib: selama `onboarded_at` kosong, tidak ada halaman lain yang
  // bisa dibuka. Admin dikecualikan — akunnya dibuat dari panel, bukan lewat
  // alur pendaftaran publik, jadi tidak punya data ini.
  if (!user?.onboarded_at && user?.role !== "administrator" && location.pathname !== "/mulai") {
    const redirect = `${location.pathname}${location.search}`
    return <Navigate to="/mulai" state={{ redirect }} replace />
  }

  return children ? <>{children}</> : <Outlet />
}
